import { useUserOrKaEmployee } from '../UserAccess/useUserOrKaEmployee';
import { HttpMethod } from './useFetch';
import useRequest, { Request, RequestOptions } from './useRequest';

export interface UserOrKaEmployeeRequestSpec {
    path: string;
    method: HttpMethod;
}

export default function useUserOrKaEmployeeRequest<Req, Resp = void>(spec: UserOrKaEmployeeRequestSpec, options?: RequestOptions<Resp>): Request<Resp, Req> {
  const authProfile = useUserOrKaEmployee();
    return useRequest<Req, Resp>({
        path: spec.path,
        method: spec.method,
        headers: authProfile.fetchHeaders,
    }, options);
}